function updateCoupon() {
    const couponsWrapper = document.querySelector('.added-coupons-wrapper')
    const data = new FormData()
    data.append('action', 'update_coupon')
    data.append('security', tlGlobal.updateCoupon)

    fetch(tlGlobal.adminUrl, {
        method: 'POST',
        body: data,
    })
        .then((response) => response.text())
        .then((data) => {
            couponsWrapper.innerHTML = data
        })
        .catch((error) => {
            console.log(error)
        })
}

// Unfournately WooCommerce uses jQuery so we need to use it here too
;(function ($) {
    $(document.body).on('applied_coupon_in_checkout', function () {
        updateCoupon()
    })
})(jQuery)
